import dayjs from 'dayjs';
import { useProcessConfiguration } from './useProcessConfiguration';

const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';

/** Company-wide date display format, set on the Process Configuration screen — every UI date
 * rendering (table columns, detail pages, etc.) should go through this instead of hardcoding its
 * own format, so changing the setting actually changes the whole app at once. Does NOT apply to
 * content baked onto physically printed labels (see LabelCanvas.tsx's sample PrintDate) — that
 * stays a fixed format independent of this per-viewing-user-facing setting. */
export function useDateFormat() {
  const { data: config } = useProcessConfiguration();
  const dateFormat = config?.dateFormat ?? DEFAULT_DATE_FORMAT;

  const formatDate = (value: string | Date | null | undefined): string => (value ? dayjs(value).format(dateFormat) : '—');

  const formatDateTime = (value: string | Date | null | undefined): string =>
    value ? dayjs(value).format(`${dateFormat} HH:mm`) : '—';

  return { dateFormat, formatDate, formatDateTime };
}
